// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import type { SxProps } from "@outschool/backpack";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

import DesktopCategoryNavbar from "./DesktopCategoryNavbar";
import DesktopCategoryNavbarButton from "./DesktopCategoryNavbarButton";
import MobileCategoryNavbar from "./MobileCategoryNavbar";
import { useAllNavbarCategories } from "./navbarCategories";

export default function CategoryNavbar({
  sx = {},
  useButton,
}: {
  sx?: SxProps;
  useButton?: boolean;
}) {
  const isMobile = useIsMobile();

  const navbarCategories = useAllNavbarCategories();

  return (
    <nav style={{ zIndex: 201, position: "relative" }}>
      {isMobile ? (
        <MobileCategoryNavbar categories={navbarCategories} sx={sx} />
      ) : useButton ? (
        <DesktopCategoryNavbarButton categories={navbarCategories} sx={sx} />
      ) : (
        <DesktopCategoryNavbar categories={navbarCategories} sx={sx} />
      )}
    </nav>
  );
}
